import { render, staticRenderFns } from "./shopsList.vue?vue&type=template&id=f2cd0a24&scoped=true"
import script from "./shopsList.vue?vue&type=script&lang=js"
export * from "./shopsList.vue?vue&type=script&lang=js"
import style0 from "./shopsList.vue?vue&type=style&index=0&id=f2cd0a24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2cd0a24",
  null
  
)

export default component.exports